<template>
    <div>
        <banner heading="ACHIEVEMENTS" description="ACHIEVEMENTSDESCRIPTION" type="achievement"></banner>
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <paginate-links for="achievements" :show-step-links="true" :limit="4"
                                    :classes="{
                                    'ul': ['pagination', 'btn-group', 'list-unstyled', 'pagination-md'],
                                    'li:not(.active)': ['btn', 'btn-secondary'],
                                    'li.active': ['btn', 'btn-primary'],
                                    '.next > a': 'next-link',
                                    '.prev > a': ['prev-link']
                                }"></paginate-links>
                </div>
                <div class="column col-md-6 col-sm-12">
                    <div class="input-group input-group-lg input-group-cstm">
                        <span class="input-group-prepend">
                            <label class="input-group-text"><i class="fa fa-filter"></i></label>
                        </span>
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <label style="margin:0;" for="hide-achieved">{{ 'HIDE_ACHIEVED' | translate }}</label>&nbsp;
                                <input v-model="hideAchieved" id="hide-achieved" type="checkbox">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <paginate name="achievements" tag="div" class="row" :list="achievements" :per="12">
                <achievement v-for="achievement in paginated('achievements')" :key="achievement.id" :achievement="achievement"></achievement>
            </paginate>
        </div>
    </div>
</template>

<script>
import achievementComponent from './Achievement.vue';
import banner from './Banner.vue';
import { mapGetters } from 'vuex';
export default {
    name:     'achievement-list',
    computed: {
        ...mapGetters({
            achievements: 'allAchievements'
        }),
        hideAchieved: {
            get() {
                return this.$store.state.game.hideAchieved;
            },
            set(hide) {
                this.$store.commit('TOGGLE_HIDE_ACHIEVED', hide);
            }
        },
        achievements() {
            return this.$store.getters.allAchievements.filter(
                ach => !this.hideAchieved || ach.isAchieved === false
            );
        }
    },
    created() {
        this.$store.dispatch('getAllAchievements');
    },
    data() {
        return { paginate: ['achievements'] };
    },
    components: {
        achievement: achievementComponent,
        banner
    }
};
</script>

<style scoped lang="less">
i.achievement-font-icon, i.shop-font-icon, i.upgrade-font-icon {
    color: #b31243;
}
</style>
